<template>
  <div class="stepModal position-relative">
    <div class="modal fade" id="affectedModal" tabindex="-1" role="dialog" aria-labelledby="affectedModal">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5><b>Affected {{ type }}s</b></h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <table v-if="type=='node'"  class="table table-striped single-outage-table">
              <thead>
              <tr class="text-center">
                <th></th>
                <th><b>Node Name</b></th>
                <th><b>Total Outages</b></th>

              </tr>
              </thead>
              <tbody>
              <tr class="text-center" v-for="(row, index) in nodesData" :key="index">
                <td></td>
                <td>{{row.name}}</td>
                <td>{{row.count}}</td>
              </tr>
              </tbody>
            </table>
            <table v-else  class="table table-striped single-outage-table">
              <thead>
              <tr class="text-center">
                <th></th>
                <th><b>Rack Name</b></th>
                <th><b>Total Outages</b></th>
                <th><b>Nodes</b></th>

              </tr>
              </thead>
              <tbody>
              <tr class="text-center" v-for="(row, index) in Object.values(racksData)" :key="index">
                <td></td>
                <td>{{row.name}}</td>
                <td>{{row.count}}</td>
                <td>{{row.nodes.join(',')}}</td>
              </tr>
              </tbody>
            </table>

          </div>


        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "affectedNodesAndRacks",
  data(){
    return {
      nodesData: [],
      racksData: [],
      type: ''
    }
  },
  methods: {
    async load(dataArray, nodes, type){
      this.type=type
      this.nodesData=[]
      this.racksData=[]
      console.log('data', dataArray)
      if(type==='node'){
        dataArray.map(el => {
          this.nodesData.push({id: el.id, count: el.count, ...nodes[`${el.id}`]})
        })
      }else{
        const groupedRacks = {};
        dataArray.forEach((item) => {
          const nodeName = nodes[item.id] ? nodes[item.id].name : ''
          if (!groupedRacks[nodes[item.id].rack.name]) {
            groupedRacks[nodes[item.id].rack.name] = { rack: nodes[item.id].rack ? nodes[item.id].rack.name : '', count: 1, name: nodes[item.id].rack ? nodes[item.id].rack.name : '', nodes:[nodeName] };
          } else {
            groupedRacks[nodes[item.id].rack.name].count += 1;
            if (!groupedRacks[nodes[item.id].rack.name].nodes.includes(nodeName)) {
              groupedRacks[nodes[item.id].rack.name].nodes.push(nodeName);
            }
          }
        });
        this.racksData = Object.values(groupedRacks)
        console.log('racks', this.racksData)
      }
      $('#affectedModal').modal('show');
    }
  }
}
</script>

<style scoped>

</style>
